import { Vue, Component, Mixins } from "vue-property-decorator";
import CollectionControl from '@/components/collection-control';
import XTh from '@/components/x-table/x-th';
import XTable from '@/components/x-table';
import ActionTd from '@/components/x-table/action-td';
import ActionTh from '@/components/x-table/action-th';
import PanelAccesContact from '@/modules/cavite-edit/components/ems/panel-acces-contact';
import CavCusAccesContactAdresse from '@/lib/models/cav-cus-acces-contact-adresse';
import { DynPanelAware } from '@/components/dyn-panel';
import PanelProprietaire from '@/modules/cavite-edit/components/ems/panel-proprietaire';
import CavCusProprietaire from '@/lib/models/cav-cus-proprietaire';
import { lexLabel, ellipsis } from '@/lib/helpers';
import RightsAware from '@/lib/mixins/rights-aware';
import CavCavite from '@/lib/models/cav-cavite';
import { State } from 'vuex-class';
import XInput from '@/components/x-input';
import XTextarea from '@/components/x-textarea';

@Component
export default class PartEmsIdentification extends Mixins(DynPanelAware, RightsAware) {

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  renderAccesContactControl() {
    return <CollectionControl
      data={this.data.cus.accesContactAdresses}
      clazz={PanelAccesContact}
      scopedSlots={{
        body: ({ data, onEdit, onDelete }) => (
          <XTable data={data}
            class="is-full-width is-bordered is-small"
            scopedSlots={{
              header: () => (
                <tr>
                  <XTh prop="typeAcces" lblFn={lexLabel}>Type</XTh>
                  <XTh prop="natureAcces">Nature</XTh>
                  <XTh prop="nom">Nom</XTh> 
                  <ActionTh/>
                </tr>
              ),
              row: ({d}: {d: CavCusAccesContactAdresse}) => (
                <tr>
                  <td>{lexLabel(d.typeAcces)}</td>
                  <td>{d.natureAcces}</td>
                  <td>{d.nom}</td>
                  <ActionTd
                    onEdit={() => onEdit(d)}
                    onDelete={() => onDelete(d)}
                  />
                </tr>
              )
            }}>
          </XTable>
        )
      }}>
    </CollectionControl>;
  }

  renderProprietaireControl() {
    return <CollectionControl
      data={this.data.cus.proprietaires}
      clazz={PanelProprietaire}
      scopedSlots={{
        body: ({ data, onEdit, onDelete }) => (
          <XTable data={data}
            class="is-full-width is-bordered is-small"
            scopedSlots={{
              header: () => (
                <tr>
                  <XTh prop="proprietaire" lblFn={lexLabel}>Nom</XTh>
                  <XTh prop="commentaire">Commentaire</XTh>
                  <ActionTh/>
                </tr>
              ),
              row: ({d}: {d: CavCusProprietaire}) => (
                <tr>
                  <td>{lexLabel(d.proprietaire)}</td>
                  <td>{ellipsis(d.commentaire, 100)}</td>
                  <ActionTd
                    onEdit={() => onEdit(d)}
                    onDelete={() => onDelete(d)}
                  />
                </tr>
              )
            }}>
          </XTable>
        )
      }}>
    </CollectionControl>;
  }

  render() {
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-5">
            <div class="field is-4">
              <label class="label is-small">
                  Identifiant EMS
              </label>
              <div class="control">
                <XInput vModel={this.data.cus.identifiant} class="input is-small"></XInput>
              </div>
            </div>
            <div class="field">
              <label class="label is-small">
                Commentaire sur le type de site
              </label>
              <div class="control">
                <XTextarea vModel={this.data.cus.typeSiteCommentaire} class="textarea is-small" rows={3}/>
              </div>
            </div>
            <div class="field">
              <label class="label is-small">
                Adresse
              </label>
              <div class="control">
                <XTextarea vModel={this.data.cus.adresseSite} class="textarea is-small" rows={3}/>
              </div>
            </div>
            <div class="field is-3">
              <label class="label is-small">
                Tel.
              </label>
              <div class="control">
                <XInput vModel={this.data.cus.telSite} class="input is-small" size={10} maxLength={20}></XInput>
              </div>
            </div>
            <div class="is-flex is-airy is-fluid">
              <div class="field is-fluid">
                <label class="label is-small">
                  Cadastre section
                </label>
                <div class="control is-6">
                  <XInput vModel={this.data.cus.cSection} class="input is-small" size={10}></XInput>
                </div>
              </div>
              <div class="field is-fluid">
                <label class="label is-small">
                  Parcelle
                </label>
                <div class="control is-6">
                  <XInput vModel={this.data.cus.noParcelle} class="input is-small" size={10}
                    maxLength={50}></XInput>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-6 is-offset-1">
            <div class="field">
              <label class="label is-small">
                Accès contacts adresses
              </label>
              {this.renderAccesContactControl()}
            </div>
            <div class="field">
              <label class="label is-small">
                Propriétaires
              </label>
              {this.renderProprietaireControl()}
            </div>
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-103cb32f/identification.tsx" });